<style lang="stylus">
    .pagefollow-filter
        padding 24px 0 24px 16px
        ul
            display flex
            li
                margin 0 16px
                user-select none
                cursor pointer
                position relative
                &:first-child
                    margin-left 6px
                p
                    font-size 12px
                    color #000
                &.active
                    p
                        font-weight 700
                    &:before
                        position absolute
                        content ''
                        left -6px
                        top 0
                        bottom 0
                        margin auto
                        display block
                        width 2px
                        height 14px
                        background-color #017FFF
    .pagefollow-follow
        position relative
        display flex
        flex-wrap wrap
        .pagefollow-showbox
            position relative
            display flex
            align-items center
            justify-content center
            flex-wrap wrap
            width 152px
            height 220px
            background #fff
            border-radius 4px
            border 1px solid #eee
            margin-right 16px
            margin-bottom 20px
            cursor pointer
            user-select none
            &.hidden-margin
                margin-right 0
            .showbox-icon
                position relative
                width 76px
                height 76px
                margin-top 28px
                .showbox-defaulticon
                    width 76px
                    height 76px
                img
                    border-radius 50%
                    width 76px
                    height 76px
                .showbox-ring
                    position absolute
                    left 0
                    top 0
                    width 76px
                    height 76px
            .showbox-info
                width 100%
                .showbox-info-nickname
                    display flex
                    align-items center
                    justify-content center
                    padding 0 10px
                    font-size 16px
                    color #000
                    margin-bottom 8px
            .showbox-follow
                position relative
                align-self flex-end
                width 100%
                height 53px
                padding 17px 22px
                border-top 1px solid #e0e0e0
                .showbox-follow-info
                    display flex
                    justify-content space-around
                    font-size 12px
                    color rgba(66, 66, 66, 1)
                .showbox-follow-btnbox
                    display none
                    justify-content center
                    align-items center
                    cursor default
                    position absolute
                    left 0
                    top 0
                    width 100%
                    height 100%
                    background #EDF5F2
                    .showbox-follow-btn
                        display inline-block
                        height 26px
                        padding 0 36px
                        text-align center
                        line-height 26px
                        background var(--themeColor)
                        color #fff
                        font-size 12px
                        border-radius 2px
                        user-select none
                        cursor pointer
                &:hover
                    .showbox-follow-btnbox
                        display flex


    .pagefollow-page
        display flex
        justify-content space-around
        margin-top 15px
        color #626262 !important

        .el-pagination
            button
                background none !important

        .el-pager li
            background none
    .dark-theme__workbench
        .pagefollow-filter
            ul
                li
                    p
                        color #fff
    .showbox-info-nickname img
        width: 20px;
        height: 20px;
        margin-left: 8px;
    .showbox-info-nickname span
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
</style>

<template>
    <div>
        <div class="pagefollow-filter">
            <ul>
                <li v-for="item in filterData" :key="item.id" :class="{ active: item.id == activeFilter }" @click="changeFilter(item)">
                    <p>{{ item.label }}</p>
                </li>
            </ul>
        </div>

        <div class="pagefollow-follow" ref="pageFollowContainer">
            <div
                class="pagefollow-showbox"
                v-for="(item, index) in showList"
                :key="index"
                @click="toUser(item.user_id)"
                :class="{ 'hidden-margin': (index + 1) % showboxCount == 0 }"
            >
                <div class="showbox-icon">
                    <iconSymbol v-if="!item.avatar && !item.avatar_url" class="showbox-defaulticon" name="default-avatar" />
                    <img v-else :src="item.avatar || item.avatar_url" alt="" />
                    <iconSymbol class="showbox-ring" :name="vipState ? 'icon-vip' : 'icon-novip'" />
                </div>
                <div class="showbox-info">
                    <p class="showbox-info-nickname">
                        <span>{{ item.nick_name }}</span>
                        <img src="https://images.edrawmax.cn/1.png" v-if="isMedal(item.user_id)" alt="" />
                    </p>
                </div>
                <div class="showbox-follow">
                    <p class="showbox-follow-info">
                        <span>{{ $t("works") + ":" + item.works_num }}</span>
                        <span>|</span>
                        <span>{{ $t("fans") + ":" + item.fans_num }}</span>
                    </p>
                    <div class="showbox-follow-btnbox" v-show="userInfo.user_id != item.user_id">
                        <div
                            class="showbox-follow-btn"
                            @click.stop="follow(item.user_id)"
                            :style="{ background: followIds.includes(item.user_id) ? '#DB5E5E' : '#037FFF' }"
                        >
                            {{ followIds.includes(item.user_id) ? $t("unFollow") : $t("follow") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="pagefollow-page">
            <Page
                v-if="pageData[activeFilter].total > 0"
                :total="pageData[activeFilter].total"
                :page-size="pageCount"
                @on-change="pageChanged"
                size="small"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageFollow",
        data() {
            return {
                pageCount: 12, // 一页几条数据
                pageData: [
                    {
                        total: 0,
                        current: 0,
                        offset: 0,
                    },
                    {
                        total: 0,
                        current: 0,
                        offset: 0,
                    },
                ],
                activeFilter: 0,
                vipState: false,
                followTimer: 0,
                showboxCount: 4,
                blockFlag: false,
            };
        },
        components: {},
        computed: {
            userInfo() {
                return this.$store.state.userInfo;
            },
            isViewer() {
                return this.$store.state.userInfo.user_id != this.$store.state.userPage.viewerID;
            },
            filterData() {
                let filterData = [
                    {
                        id: 0,
                        label: `${this.isViewer ? this.$t("followLabel") : this.$t("followLabel_self")}  ${this.followData[0].num}`,
                        value: 0,
                    },
                    {
                        id: 1,
                        label: `${this.isViewer ? this.$t("fansLabel") : this.$t("fansLabel_self")}  ${this.followData[1].num}`,
                        value: 1,
                    },
                ];
                return filterData;
            },
            followData() {
                return this.$store.state.userPage.followData;
            },
            followList() {
                return this.followData[0].data;
            },
            fansList() {
                return this.followData[1].data;
            },
            showList() {
                let arr = [];
                let p = this.pageData[this.activeFilter];
                let temp = JSON.parse(JSON.stringify(this.activeFilter == 0 ? this.followList : this.fansList));
                arr = temp.splice(p.offset, this.pageCount);

                return arr;
            },
            followIds() {
                return this.$store.state.userPage.followIds;
            },
            clickUserWordIds() {
                return this.$store.state.userPage.clickUserWordIds;
            },
            medalIds() {
                return this.$store.state.medalIds;
            },
        },
        props: {},
        methods: {
            isMedal(id) {
                return this.medalIds.includes(id);
            },
            changeFilter(obj) {
                this.activeFilter = obj.id;
            },
            pageChanged(page) {
                console.log(this.activeFilter, page);
                this.pageData[this.activeFilter].current = page;
                this.pageData[this.activeFilter].offset = (this.pageData[this.activeFilter].current - 1) * this.pageCount;
            },
            follow(id) {
                if (!this.$validateLogin()) {
                    this.$store.commit("toTplCenter", {
                        name: "showUserWorks",
                        data: false,
                    });
                    return;
                }
                if (this.followTimer) {
                    clearTimeout(this.followTimer);
                }
                this.followTimer = setTimeout(() => {
                    this.$store.dispatch("userPage/followOthers", {
                        follow: !this.followIds.includes(id),
                        id,
                        type: this.activeFilter == 0 ? "follow" : "fans",
                    });
                }, 350);
            },
            toUser(id) {
                if (!this.$validateLogin()) {
                    this.$store.commit("toTplCenter", {
                        name: "showUserWorks",
                        data: false,
                    });
                    return;
                }
                this.$store.commit("toVisitUser", {
                    id,
                });
                this.$bus.$emit("reloadUser");
                let len = this.clickUserWordIds.length;
                if ((len >= 1 && this.clickUserWordIds[len - 1] != id) || len == 0) {
                    this.$store.commit("userPage/clickUserWordId", id);
                }
            },
            resizeFit() {
                if (this.blockFlag) {
                    return;
                }
                this.blockFlag = true;
                this.timer = setTimeout(() => {
                    let pageFollowContainer = this.$refs.pageFollowContainer;
                    if (pageFollowContainer) {
                        let w = pageFollowContainer.offsetWidth;
                        const boxW = 151,
                            boxMargin = 16;
                        this.showboxCount = Math.floor((w + boxMargin) / (boxW + boxMargin));
                        console.log(this.showboxCount);
                    }
                    this.blockFlag = false;
                }, 200);
            },
        },
        mounted() {
            this.pageData[0].total = this.followList.length;
            this.pageData[1].total = this.fansList.length;
            let pageFollowContainer = this.$refs.pageFollowContainer;
            // 满两行
            this.pageCount = Math.floor(pageFollowContainer.offsetWidth / 152) * 2;
        },
        created() {
            this.resizeFit();
            window.addEventListener("resize", this.resizeFit);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeFit);
        },
    };
</script>
<i18n>
{
  "zh": {
    "works": "创作",
    "fans": "粉丝",
    "following": "关注",
    "collect": "收藏",
    "follow": "关注",
    "unFollow": "取消关注",
    "followLabel": "TA关注的",
    "fansLabel": "关注TA的人",
    "followLabel_self": "我关注的",
    "fansLabel_self": "关注我的人"
  },
  "en": {
    "works": "Works",
    "fans": "Followers",
    "following": "Following",
    "collect": "Collect",
    "follow": "Follow",
    "unFollow": "Unfollow",
    "followLabel": "Follow",
    "fansLabel": "Fans",
    "followLabel_self": "Follow",
    "fansLabel_self": "Fans"
  },
  "kr": {
    "works": "작업물",
    "fans": "팔로워",
    "following": "팔로잉",
    "collect": "즐겨찾기",
    "follow": "팔로우",
    "unFollow": "팔로우 취소하기",
    "followLabel": "팔로우",
    "fansLabel": "팔로워",
    "followLabel_self": "팔로우",
    "fansLabel_self": "팔로워"
  },
  "tw": {
    "works": "作品",
    "fans": "粉絲",
    "following": "關注",
    "collect": "收藏",
    "follow": "關注",
    "unFollow": "取消關注",
    "followLabel": "TA關注的",
    "fansLabel": "關注TA的人",
    "followLabel_self": "我關注的",
    "fansLabel_self": "關注我的人"
  },
  "jp": {
    "works": "作品",
    "fans": "フォロワー",
    "following": "フォロー",
    "collect": "お気に入り",
    "follow": "フォロー",
    "unFollow": "フォロー解除",
    "followLabel": "フォロー",
    "fansLabel": "フォロワー",
    "followLabel_self": "フォロー",
    "fansLabel_self": "フォロワー"
  },
  "id": {
    "works": "Karya",
    "fans": "Pengikut",
    "following": "Mengikuti",
    "collect": "Kumpulkan",
    "follow": "Ikuti",
    "unFollow": "Berhenti mengikuti",
    "followLabel": "Ikuti",
    "fansLabel": "Penggemar",
    "followLabel_self": "Ikuti",
    "fansLabel_self": "Penggemar"
  }
}
</i18n>
